<template>
    <div>
        <form v-if="affiliate" class="form" v-on:submit.prevent="updateAffiliate">
        <h1>Affiliate: {{ affiliate.name }}</h1>
        <div class="box">
            <Errors/>
            <AffiliateFields/>
            <div class="form-wrap form-submit">
            <div class="mt-1" v-if="this.getLoadStatus">
                <button type="submit" class="button" disabled><span>Updating...</span></button>
            </div>
            <div class="mt-1" v-else>
                <button type="submit" class="button" v-if="userRole == 1"><span>Update affiliate</span></button>
            </div>
            </div>
        </div>
        </form>
    </div>
</template>

<script>
import AffiliateFields from '../AffiliateFields.vue'
import Errors from '@/components/Errors.vue'
import { mapGetters } from 'vuex'

export default {
    name: 'AffiliateBasicDetails',
    props: {
        affiliate:Object,
    },
    computed: {
        ...mapGetters(['getLoadStatus']),
        userRole() {
            return localStorage.getItem("user_role");
        }
    },
    components: {
        AffiliateFields,
        Errors
    },
    methods: {
        updateAffiliate() {
            this.$store.dispatch('setLoadStatus')
            fetch(this.$api + 'affiliates/' + this.$route.params.id, {
                method: 'POST',
                body: JSON.stringify(this.affiliate),
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': localStorage.getItem('token')
                }
            })
                .then(res => res.json())
                .then(response => {
                    if (response.success) {
                        this.$notify({
                            type: 'success',
                            title: response.message
                        });
                    } else if (response.errors) {
                        this.$notify({
                            type: 'error',
                            title: response.message
                        });
                    }
                    this.$store.dispatch('setLoadStatus')
                });
        }
    }
}
</script>

<style lang="scss" scoped>

</style>